import React from 'react'
import { map } from 'lodash'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay } from 'swiper'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import Testimonials from 'data/testimonials'

function TestimonialSlider({ theme, offsetBefore, offsetBeforeMobile }) {
  SwiperCore.use([Autoplay])
  const { m: isMobile } = useBreakpoint()

  function renderCitation(item) {
    const { name, title } = item.citation
    return (
      <div className="testimonials__blockquote-citation">
        <span>{name}</span>
        <span>{title}</span>
      </div>
    )
  }

  function renderBlockquote(item) {
    const { quote } = item
    return <p>{quote}</p>
  }

  return (
    <section className={cx('testimonials__section', `--${theme}`)}>
      <div className="testimonials__blockquote">
        <div className="testimonials__blockquote-slider">
          <Swiper
            spaceBetween={isMobile ? 35 : 110}
            slidesPerView={isMobile ? 1.2 : 1.25}
            slidesOffsetBefore={isMobile ? offsetBeforeMobile : offsetBefore}
            loop
            slideToClickedSlide
            autoplay={{
              delay: 10000,
            }}
          >
            {map(Testimonials, (item, index) => (
              <SwiperSlide key={`swiper_slide_${index}`}>
                <div className="testimonials__blockquote-slide">
                  <blockquote>
                    <cite>{renderCitation(item)}</cite>
                    {renderBlockquote(item)}
                  </blockquote>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  )
}

TestimonialSlider.defaultProps = {
  offsetBefore: 100,
  offsetBeforeMobile: 15,
}

TestimonialSlider.propTypes = {
  theme: PropTypes.string,
  offsetBefore: PropTypes.number,
  offsetBeforeMobile: PropTypes.number,
}

export default TestimonialSlider
